export default __webpack_public_path__ + "static/walter-5017a33018297e47fbc2d39eb8208e47.png";